import { Grid, IconButton, TextField, Tooltip } from '@mui/material';
import React from 'react'
import { useSelector } from 'react-redux'
import SharedDialog from '../../common/dialog/SharedDialog';

const MultiLangDialogAndSingleDisplayIpt = ({
    item = false,
    optionIdx,
    keyName,
    itemKeyName,
    valueObj,
    handleMultiIptChange,
    handleOptions
}) => {

    const lang = useSelector(state => state.lang.ui.lang);
    const [open, setOpen] = React.useState(false)

    const handleToggleOpen = () => setOpen(!open)

    return (
        <React.Fragment>
            {
                item ? (
                    <TextField
                        variant='outlined'
                        type='text'
                        label={'Option' + (optionIdx + 1)}
                        name={"" + optionIdx}
                        value={valueObj?.[lang]}
                        color='success'
                        InputProps={{
                            endAdornment: <Tooltip title="delete"><IconButton disableRipple color='success' onClick={handleOptions('d', { keyName, itemKeyName })}>-</IconButton></Tooltip>,
                        }}
                        // onChange={handleOptions()}
                        onClick={handleToggleOpen}
                    />
                ) : (
                    <TextField
                        variant='filled'
                        type='text'
                        label={keyName}
                        name={keyName}
                        value={valueObj?.[lang]}
                        color='success'
                        onClick={handleToggleOpen}
                    />
                )
            }
            <SharedDialog
                maxWidth='md'
                open={open}
                onClose={() => setOpen(false)}
                title={item ? `Option ${optionIdx + 1}` : keyName}
                content={
                    <Grid container spacing={1}>
                        {valueObj && (valueObj instanceof Object) && Object.keys(valueObj).map(key => (
                            <Grid key={key} item xs={4}>
                                <TextField
                                    multiline
                                    variant='filled'
                                    type='text'
                                    label={key}
                                    name={key}
                                    inputProps={{ 'data-key-name': keyName, 'data-item-key-name': itemKeyName }}
                                    defaultValue={valueObj[key]}
                                    color='success'
                                    rows={6}
                                    sx={{ width: '100%' }}
                                    onChange={handleMultiIptChange}
                                />
                            </Grid>
                        ))}
                    </Grid>
                }
            />
        </React.Fragment>
    )
}

export default MultiLangDialogAndSingleDisplayIpt